/* @generated */

// src/assets/ui-icon/line/one-click-nda.tsx
import * as React from "react";
var OneClickNdaLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M13.75 7.5V4h-1.5v3.5h1.5Zm-2.72.47-2.5-2.5-1.06 1.06 2.5 2.5 1.06-1.06Zm5 1.06 2.5-2.5-1.06-1.06-2.5 2.5 1.06 1.06Zm.47 2.72H20v-1.5h-3.5v1.5Zm-1.53 2.28 2.5 2.5 1.06-1.06-2.5-2.5-1.06 1.06Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11 20-2.5-4.5L4 13l10.5-3.5L11 20Zm-.345-3.71-1.052-1.893-1.894-1.052 4.42-1.473-1.474 4.419Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  OneClickNdaLine
};
